export default {
  state: {
    vecchio: "",
    calculationType: "",
    typeOfPhe: "",
    typeOfPheChannel: ""
  },
  mutations: {
    cambiaTab(state, nuovo) {
      state.vecchio = nuovo;
    },
    changeCalculationType(state, nuovoCalculationType) {
      state.calculationType = nuovoCalculationType;
    },
    changeTypeOfPhe(state, nuovoType) {
      state.typeOfPhe = nuovoType;
    },
    changeTypeOfPheChannel(state, nuovoType) {
      state.typeOfPheChannel = nuovoType;
    }
  },
  getters: {
    nuovo: state => state.vecchio,
    nuovoCalculationType: state => state.calculationType,
    typeOfPhe: state => state.typeOfPhe,
    typeOfPheChannel: state => state.typeOfPheChannel
  }
};
